import React, { useState, useEffect }  from "react";
import { setPageTitle }                from "../../../utils/document";
import useAuth                         from "../../../hooks/useAuth";
import DashboardLayout                 from "../../../components/layout/DashboardLayout";
import MyAllocations                   from "./components/MyAllocations";
import AssociateMaster                 from "../PMO/components/AssociateMaster";
import SCGPool                         from "../PMO/components/SCGPool";
import { getSowsByMac }                from "../../../api/macs";
import StatusFlow                      from "./components/StatusFlow";
import Reports from "../PMO/components/Reports";
import PositionIDManagement from "../PMO/components/PositionIDManagement";

const MAC_TABS = [
  { id: "my-allocations",  label: "My Allocations"  },
  { id: "status-flow",     label: "Status Flow"     },
  { id: "scg-pool",        label: "SCG Pool"        },
  { id: "associate-master",label: "Associate Master"},
  { id: "positions",       label: "Positions"       },
  { id: "reports",         label: "Reports"         },
];

const MACLeaderDashboard = () => {
  const { user }                    = useAuth();
  const [activeTab, setActiveTab]   = useState("my-allocations");
  const [sows, setSows]             = useState([]);

  useEffect(() => { setPageTitle("MAC Leader Dashboard"); }, []);

  // Fetch SOWs for this MAC Leader's MAC once user + macId is available
  useEffect(() => {
    if (!user?.macId) return;
    getSowsByMac(user.macId)
      .then(setSows)
      .catch((err) => console.error("Failed to load SOWs:", err));
  }, [user?.macId]);

  return (
    <DashboardLayout
      tabs={MAC_TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      // Show MAC code (e.g. "MAC-1") in AppBar instead of "MAC Leader"
      macBadge={user?.macCode ?? null}
    >
      {activeTab === "my-allocations"   && user && <MyAllocations sows={sows} />}
      {activeTab === "status-flow"      && <StatusFlow />}
      {activeTab === "scg-pool"         && <SCGPool />}
      {activeTab === "associate-master" && <AssociateMaster />}
      {activeTab === "positions"        && (
        <PositionIDManagement
          readOnly={true}
          singleMacMode={true}
          macsList={user?.macId ? [{ macId: user.macId, macName: user.macName, sowCount: sows.length, sows }] : []}
        />
      )}
      {activeTab === "reports"          && <Reports macIdFilter={user?.macId} />}
    </DashboardLayout>
  );
};

export default MACLeaderDashboard;